import { render } from "./ApiDoc.vue?vue&type=template&id=066f648a"
import script from "./ApiDoc.vue?vue&type=script&lang=js"
export * from "./ApiDoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__